import React, { Component } from "react";

import { CCard, CCardHeader, CCol, CButton } from "@coreui/react";

import axios from "../../config/axios";
import Loading from "../Loading";

class StiftIntegrationComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggingToStift: false,
      loadingQRCode: true,
      missingCredentials: false,
      undefinedCredentials: [],
      authToken:
        "^hZjLs97uCC9ohNDcCn$TAXtKxfUhTYUwGrFWf6cdkz8gt7A53x@SA^VDb57JBKDe6Vh8YZYiJ$5diV@kJEQXxKAY*TrarhStwuaw^GsVCUkwcU*mKcGGSUHDu@EFStm",
      QRCode: ""
    };
  }

  signUpForStift() {
    this.setState({ loggingToStift: true });

    const userData = this.props.userData;
    const userDataToSend = {
      first_name: userData.user.name,
      last_name: userData.user.surname ? userData.user.surname : "",
      email: userData.user.email,
      location: userData.user_complememt.city,
      gender:
        userData.user_complememt.gender === "Masculino"
          ? "MASCULINE"
          : "FEMININE",
      type: "STUDENT",
      group_ids: ["f1a01472-f554-452b-a8a3-5e258de3c6b4"],
      groups_data: [
        {
          group: {
            id: "f1a01472-f554-452b-a8a3-5e258de3c6b4"
          },
          remaining_questions: -1
        }
      ],
      password: "stift123"
    };

    axios
      .post(`https://api.stift.com.br/v1/users`, userDataToSend, {
        headers: { Authorization: `Bearer ${this.state.authToken}` }
      })
      .then(() => {
        this.renderQRCode();
      })
      .catch(err => {
        if (err.response.status === 400) {
          const missingCredentials =
            this.checkMissingCredntials(userDataToSend);
          if (missingCredentials.length > 0) {
            this.setState({
              missingCredentials: true,
              undefinedCredentials: missingCredentials
            });
          } else {
            this.setState({ loggingToStift: false, loadingQRCode: false });
          }
        }
      });
  }

  checkMissingCredntials(userData) {
    const missingCredentials = [];

    if (!userData.first_name) {
      missingCredentials.push("Nome");
    }

    if (!userData.last_name) {
      missingCredentials.push("Sobrenome");
    }

    if (!userData.email) {
      missingCredentials.push("Email");
    }

    if (!userData.location) {
      missingCredentials.push("Cidade");
    }

    if (!userData.gender) {
      missingCredentials.push("Gênero");
    }

    return missingCredentials;
  }

  renderQRCode() {
    const userDataToSend = {
      user_email: this.props.userData.user.email
    };

    axios
      .post(`https://api.stift.com.br/v1/auth/codes`, userDataToSend, {
        headers: { Authorization: `Bearer ${this.state.authToken}` }
      })
      .then(resp => {
        this.setState({ QRCode: resp.data.qr_code, loadingQRCode: false });
      });
  }

  render() {
    return (
      <>
        <CCard className="h-100">
          <CCardHeader className="d-flex flex-column">
            <h4 className="mb-1">Stift</h4>
            <div className="small text-muted">Acesse sua conta no Stift</div>
          </CCardHeader>
          <div className="w-100 h-100 d-flex flex-row">
            <CCol className="p-3 m-0 font-weight-bold">
              <div style={{ marginBottom: "55%" }}>
                <h2>Como acesso minha conta no Stift?</h2>
                <ul className="h3">
                  <li>1 - Clique no botão ao lado para gerar seu QRCode.</li>
                  <li>2 - Aponte a câmera do seu celular* para o QRCode.</li>
                  <li>3 - Baixe o aplicativo.</li>
                </ul>
              </div>
              <div>
                <h6 className="m-0">
                  *Caso o seu aplicativo de câmera não escaneie QRCode de forma
                  nativa, baixe algum leitor de QRCode na sua loja virtual de
                  aplicativos
                </h6>
              </div>
            </CCol>
            <CCol
              className="d-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#EBEBEB" }}
            >
              {!this.state.loggingToStift ? (
                <CButton
                  color="secondary"
                  onClick={() => this.signUpForStift()}
                >
                  Gerar QRCode
                </CButton>
              ) : this.state.missingCredentials ? (
                <div>
                  <h5 className="text-center">
                    Falta(m) informação(ões) para acessar o Stift
                  </h5>
                  <h6 className="text-center">
                    Por favor, atualize as informações abaixo: <br />
                    {this.state.undefinedCredentials.map((credential, i) => (
                      <span key={i}>
                        {credential}
                        {i === this.state.undefinedCredentials.length - 2
                          ? ""
                          : ","}{" "}
                        {i === this.state.undefinedCredentials.length - 2
                          ? "e "
                          : ""}
                      </span>
                    ))}
                    <br />
                    <small className="text-muted">
                      (Você pode atualizar suas informações na aba Perfil)
                    </small>
                  </h6>
                </div>
              ) : this.state.loadingQRCode ? (
                <Loading />
              ) : (
                <img className="rounded" src={this.state.QRCode} />
              )}
            </CCol>
          </div>
        </CCard>
      </>
    );
  }
}

export default StiftIntegrationComponent;
